import { InvestablePeriodRate, InvestableTypeEnum } from "./Deal";
import { FileInterface } from "./Documents";

export const currencyEnum = ["GBP", "USD"] as const;
export const currencySymbolEnum = ["£", "$"] as const;
export type CurrencyEnumType = (typeof currencyEnum)[number];
export type CurrencySymbolEnumType = (typeof currencySymbolEnum)[number];
export type CurrencySymbolMapType = Record<
  CurrencyEnumType,
  CurrencySymbolEnumType
>;

export const CURRENCY_SYMBOL_MAP: CurrencySymbolMapType = {
  GBP: "£",
  USD: "$",
};

export interface Investable {
  id: string;
  name: string;
  description: string | null;
  displayImage?: FileInterface | null;
  /** IconPark name chosen in Nucleus; every deal of this investable shows it. */
  icon?: string | null;
  backgroundImage?: FileInterface | null;
  type?: InvestableTypeEnum | null;
  website: string | null;
  twitter: string | null;
  linkedIn: string | null;
  companiesHouseUrl: string | null;
  hasRegulatoryWarning: boolean;
  currency: CurrencyEnumType;
  created_at: string;
  updated_at?: string | null;
  metadata?: {
    assetClass?: string;
    distributionFrequency?: "QUARTERLY" | "SEMI_ANNUAL" | "ANNUAL";
    [x: string]: unknown;
  };
  /** The fund's full rate ladder, present on period deals when served. */
  periodRates?: InvestablePeriodRate[];
}
